<template>
<v-card flat>
    <v-card-title>
      <div>
        <h3 class="subheading">Text message</h3>
        <div class="caption grey--text">{{cMessage.name}}</div>
      </div>
      <v-spacer></v-spacer> 
          <v-btn icon @click="cancelCard"><v-icon>clear</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>  
    <v-container grid-list-xl>
          <v-layout class="mt-0" row wrap>                       
            <!-- <v-flex class="mt-0" xs12>
              <v-textarea
                auto-grow
                v-model="text"
                label="Personalised text message"
                counter="2000"
                :hint="hint"
                rows="1"
                persistent-hint
              ></v-textarea>                                                     
            </v-flex> 
            <v-flex class="mt-0" xs12>
              <v-textarea
                auto-grow
                v-model="fallback_text"
                label="Fallback text mesage"
                counter="2000"
                rows="1"
                hint="Incase if we are unable to get personalised variables this message will trigger"
                persistent-hint
              ></v-textarea>                                                     
            </v-flex>                        -->
            <v-flex class="mt-0" xs12>
              <v-textarea
                auto-grow
                v-model="text"
                label="Text Message"                
                placeholder="Write the text message here"
                counter="2000"
                rows="1"
                v-on:keyup.shift.219="cusevent"
                class="body-1 font-weight-regular"
              ></v-textarea>                                                     
            </v-flex>
            </v-layout>                  
        </v-container>
        <v-card-actions class="ma-0">
            <v-spacer></v-spacer>                  
                <v-btn round flat color="primary" @click="cancelCard">Cancel</v-btn>
                <v-btn round flat color="primary" @click="saveCard">Save</v-btn>                
        </v-card-actions>  
        </v-card>
</template>

<script>
export default {
  data(){
    return{
      text:null,
      fallback_text:null,
      type:"text",
      hint:"currently text message supports personalised variables {{first_name}} and {{last_name}}"
    }
  },
  methods:{
    saveCard(){
      let index = this.$store.state.bTemplateindex  
      let textmessage = {"text":this.text}    
      //let textmessage =  {"dynamic_text": { "text": this.text, "fallback_text": this.fallback_text}} 
      let message = {"message":textmessage,"type":"text"}      
      this.$store.dispatch('acreatebcastTextMessage', {index,message})
      this.text = null
      let status = false
      this.$store.dispatch('abcastmenuStatusChange',status)
    },
    cancelCard(){
      let status = false
      this.$store.dispatch('abcastmenuStatusChange',status)
    }
  },
  computed:{
    cMessage(){
        if(this.$store.state.bTemplateindex != null){
          return this.$store.state.bTemplateNames[this.$store.state.bTemplateindex]  
        }          
        }
  }
}
</script>
